"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailNotFoundState = void 0;
var NotFoundState_init_1 = require("@/pages/notFound/states/NotFoundState.init");
exports.defaultDetailNotFoundState = {
    notFound: NotFoundState_init_1.defaultNotFoundState,
    showPropertyInfo: false,
};
